export { default } from './ProductsSection';

require('./ProductsSection.scss');